export default function StandardCenterCenter({ children }){


    return (
        <div style={{ justifyContent: 'center', alignItems:'center', display: 'flex', flexDirection:'column' }}>
                {children}
        </div>
    )
}